import React from 'react'
import { Button, ButtonProps } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import { useStyles } from './styles'

export interface ButtonActionProps extends ButtonProps {
  text: string
  bold?: boolean
  loading?: boolean
  color?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success'
  variant?: 'contained' | 'outlined' | 'text'
  loaderColor?: string
}

const ButtonAction: React.FC<ButtonActionProps> = ({
  text,
  bold,
  loading,
  className = '',
  color = 'primary',
  variant = 'contained',
  loaderColor = '#fff',
  ...props
}) => {
  const classes = useStyles()

  return (
    <Button variant={variant} color={color} className={`${className} ${bold ? classes.bold : ''}`} {...props}>
      {text}
      {loading && <CircularProgress size={16} style={{ color: loaderColor }} />}
    </Button>
  )
}

export default ButtonAction
